import axios from "axios";
import { Dispatch } from "redux";
import {
  DELETE_GOVERNMENT_FEEDBACK,
  DELETE_POLITICALPARTY_FEEDBACK,
  DELETE_POLITICIAN_FEEDBACK,
  SET_COUNTRIESDATA,
  SET_GOVERNMENTDATA,
  SET_GOVERNMENTSDATA,
  SET_POLITICALPARTIESDATA,
  SET_POLITICALPARTYDATA,
  SET_POLITICIANDATA,
  SET_POLITICIANSDATA,
  SET_SEARCH_GOVERNMENTSDATA,
  SET_SEARCH_POLITICALPARTIESDATA,
  SET_SEARCH_POLITICIANSDATA,
  SUBMIT_GOVERNMENT_FEEDBACK,
  SUBMIT_PARTY_FEEDBACK,
  SUBMIT_POLITICIAN_FEEDBACK,
} from "../../types/data/DataActionTypes";
import {
  LOADING_GOVERNMENT_UI,
  LOADING_POLITICALPARTY_UI,
  LOADING_POLITICIAN_UI,
  LOADING_UI,
  STOP_LOADING_GOVERNMENT_UI,
  STOP_LOADING_POLITICALPARTY_UI,
  STOP_LOADING_POLITICIAN_UI,
  STOP_LOADING_UI,
} from "../../types/ui/UiReducerTypes";
const api = axios.create({
  baseURL: "https://good-regime.herokuapp.com",
  // baseURL: "http://localhost:90",
  headers: { Authorization: localStorage.userToken },
});

export const getCountries = () => async (dispatch: Dispatch) => {
  try {
    const res = await api.get("/user/getAllCountries");
    dispatch({ type: SET_COUNTRIESDATA, payload: res.data });
  } catch (err) {
    console.log(err);
  }
};

export const getPoliticians = () => async (dispatch: Dispatch) => {
  dispatch({ type: LOADING_POLITICIAN_UI });
  try {
    const res = await api.get("/user/getAllPoliticians");
    dispatch({ type: SET_POLITICIANSDATA, payload: res.data });
    dispatch({ type: STOP_LOADING_POLITICIAN_UI });
  } catch (err) {
    console.log(err);
  }
};
export const getPoliticiansSearchRes =
  (country: string) => async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_POLITICIAN_UI });
    try {
      const res = await api.get("/user/searchPolitician/" + country);
      dispatch({ type: SET_SEARCH_POLITICIANSDATA, payload: res.data });
      dispatch({ type: STOP_LOADING_POLITICIAN_UI });
    } catch (err) {
      console.log(err);
    }
  };

export const getPolitician =
  (politicianId: string) => async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_POLITICIAN_UI });
    try {
      const res = await api.get(`/user/getPolitician/${politicianId}`);
      dispatch({ type: SET_POLITICIANDATA, payload: res.data });
      dispatch({ type: STOP_LOADING_POLITICIAN_UI });
    } catch (err) {
      console.log(err);
    }
  };

export const submitPoliticianFeedback =
  (politicianId: string, feedbackData: IReviews) => (dispatch: Dispatch) => {
    dispatch({ type: LOADING_UI });
    api
      .put(`/user/politician/addReview/${politicianId}`, feedbackData)
      .then((res) => {
        if (res.data.success == true) {
          dispatch({
            type: SUBMIT_POLITICIAN_FEEDBACK,
            payload: res.data,
          });
          dispatch({ type: STOP_LOADING_UI });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: STOP_LOADING_UI });
      });
  };
export const deletePoliticianFeedback =
  (politicianId: string, feedbackId: string) => (dispatch: Dispatch) => {
    dispatch({ type: LOADING_UI });
    api
      .delete(`/user/politician/deleteReview/${politicianId}/${feedbackId}`)
      .then(() => {
        dispatch({ type: DELETE_POLITICIAN_FEEDBACK, payload: feedbackId });
        dispatch({ type: STOP_LOADING_UI });
      })
      .catch((err) => console.log(err));
  };
//------------------------------------------------------------------------------------------------------------------------

export const getPoliticalParties = () => async (dispatch: Dispatch) => {
  dispatch({ type: LOADING_POLITICALPARTY_UI });
  try {
    const res = await api.get("/user/getAllPoliticalParties");
    dispatch({
      type: SET_POLITICALPARTIESDATA,
      payload: res.data,
    });
    dispatch({ type: STOP_LOADING_POLITICALPARTY_UI });
  } catch (err) {
    console.log(err);
  }
};

export const getPoliticalParty =
  (partyId: string) => async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_POLITICALPARTY_UI });
    try {
      const res = await api.get(`/user/getPoliticalParty/${partyId}`);
      dispatch({
        type: SET_POLITICALPARTYDATA,
        payload: res.data,
      });
      dispatch({ type: STOP_LOADING_POLITICALPARTY_UI });
    } catch (err) {
      console.log(err);
    }
  };
export const getPoliticalPartiesSearchRes =
  (country: string) => async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_POLITICALPARTY_UI });
    try {
      const res = await api.get("/user/searchPoliticalParty/" + country);
      dispatch({
        type: SET_SEARCH_POLITICALPARTIESDATA,
        payload: res.data,
      });
      dispatch({ type: STOP_LOADING_POLITICALPARTY_UI });
    } catch (err) {
      console.log(err);
    }
  };

export const submitPoliticalPartyFeedback =
  (partyId: string, feedbackData: string) => (dispatch: Dispatch) => {
    dispatch({ type: LOADING_UI });

    api
      .put(`/user/politicalParty/addReview/${partyId}`, feedbackData)
      .then((res) => {
        if (res.data.success == true) {
          dispatch({
            type: SUBMIT_PARTY_FEEDBACK,
            payload: res.data,
          });
          dispatch({ type: STOP_LOADING_UI });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: STOP_LOADING_UI });
      });
  };
export const deletePartyFeedback =
  (partyId: string, feedbackId: string) => (dispatch: Dispatch) => {
    dispatch({ type: LOADING_UI });
    api
      .delete(`/user/politicalParty/deleteReview/${partyId}/${feedbackId}`)
      .then(() => {
        dispatch({ type: DELETE_POLITICALPARTY_FEEDBACK, payload: feedbackId });
        dispatch({ type: STOP_LOADING_UI });
      })
      .catch((err) => console.log(err));
  };
//--------------------------------------------------------------------------------------
export const getGovernments = () => async (dispatch: Dispatch) => {
  dispatch({ type: LOADING_GOVERNMENT_UI });
  try {
    const res = await api.get("/user/getAllGovernment");
    dispatch({ type: SET_GOVERNMENTSDATA, payload: res.data });
    dispatch({ type: STOP_LOADING_GOVERNMENT_UI });
  } catch (err) {
    console.log(err);
  }
};
export const getGovernment = (govId: string) => async (dispatch: Dispatch) => {
  dispatch({ type: LOADING_GOVERNMENT_UI });
  try {
    const res = await api.get(`/user/getGovernment/${govId}`);
    dispatch({ type: SET_GOVERNMENTDATA, payload: res.data });
    dispatch({ type: STOP_LOADING_GOVERNMENT_UI });
  } catch (err) {
    console.log(err);
  }
};
export const getGovernmentsSearchRes =
  (country: string) => async (dispatch: Dispatch) => {
    dispatch({ type: LOADING_GOVERNMENT_UI });
    try {
      const res = await api.get("/user/searchGovernment/" + country);
      dispatch({ type: SET_SEARCH_GOVERNMENTSDATA, payload: res.data });
      dispatch({ type: STOP_LOADING_GOVERNMENT_UI });
    } catch (err) {
      console.log(err);
    }
  };
export const submitGovernmentFeedback =
  (government: string, feedbackData: string) => (dispatch: Dispatch) => {
    dispatch({ type: LOADING_UI });
    api
      .put(`/user/government/addReview/${government}`, feedbackData)
      .then((res) => {
        if (res.data.success == true) {
          dispatch({
            type: SUBMIT_GOVERNMENT_FEEDBACK,
            payload: res.data,
          });
          dispatch({ type: STOP_LOADING_UI });
        }
      })
      .catch((err) => {
        console.log(err);
        dispatch({ type: STOP_LOADING_UI });
      });
  };
export const deleteGovernmentFeedback =
  (govId: string, feedbackId: string) => (dispatch: Dispatch) => {
    dispatch({ type: LOADING_UI });
    api
      .delete(`/user/government/deleteReview/${govId}/${feedbackId}`)
      .then(() => {
        dispatch({ type: DELETE_GOVERNMENT_FEEDBACK, payload: feedbackId });
        dispatch({ type: STOP_LOADING_UI });
      })
      .catch((err) => console.log(err));
  };
